module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-02.ebab2511.svg";